var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.265,
    height: 151.265,
    viewBox: "0 0 151.265 151.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1363 -362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.632,0A75.632,75.632,0,1,1,0,75.632,75.632,75.632,0,0,1,75.632,0Z",
    transform: "translate(1363 362)",
    fill: "#e05f5f",
    opacity: 0.625
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109.34,
    height: 109.34,
    rx: 54.67,
    transform: "translate(1406.396 368) rotate(20)",
    fill: "#e05f5f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1405.516 405.053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.11,32.58c0,17.993-15.023,32.58-33.555,32.58S0,50.573,0,32.58,15.023,0,33.555,0,67.11,14.586,67.11,32.58Zm0,0",
    transform: "translate(0)",
    fill: "#e05f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.738,18.069C25.5,12.9,27.893,5.537,28.979,1.036A16.941,16.941,0,0,0,23.163,0C10.37,0,0,14.586,0,32.58s10.371,32.58,23.164,32.58A16.753,16.753,0,0,0,26,64.918C15.928,53.033,14.422,40.828,15.081,32.3c.434-5.622,2.474-10.771,5.657-14.227Zm0,0",
    transform: "translate(0 0)",
    fill: "#e05f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.845,126.371l9.463-9.079a6.8,6.8,0,0,0,0-9.866,7.514,7.514,0,0,0-10.284,0l-9.463,9.079a3.134,3.134,0,0,1-4.3,0l-9.463-9.079a7.514,7.514,0,0,0-10.284,0,6.8,6.8,0,0,0,0,9.866l9.463,9.079a2.836,2.836,0,0,1,0,4.127l-9.463,9.079a6.8,6.8,0,0,0,0,9.866,7.514,7.514,0,0,0,10.284,0l9.463-9.079a3.134,3.134,0,0,1,4.3,0l9.463,9.079a7.514,7.514,0,0,0,10.284,0,6.8,6.8,0,0,0,0-9.866l-9.463-9.079A2.835,2.835,0,0,1,141.845,126.371Zm0,0",
    transform: "translate(-95.855 -95.855)",
    fill: "#f7f7f7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.4e6c484e04eb50301a89556a59c8e2d4.svg";
export { ForwardRef as ReactComponent };